import Api from '../helpers/Api'

const parseRes = res => res.json();

const ProdutoService = {
	getList: () => fetch(Api.produtoList(), { method: 'GET' }).then(parseRes),
	getById: (id) => fetch(Api.produtoById(id), { method: 'GET' }).then(parseRes),
	create: (p) =>
		fetch(Api.createProduto(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			mode: 'cors',
			body: JSON.stringify(p),
		}).then(parseRes),
	updateById: (id, p) =>
		fetch(Api.updateProdutoById(id), {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			mode: 'cors',
			body: JSON.stringify(p),
		}).then(parseRes),
	deleteById: (id) =>
		fetch(Api.deleteProdutoById(id), {
			method: 'DELETE',
			mode: 'cors',
		}).then(parseRes),
};

export default ProdutoService;
